module.exports = __webpack_public_path__ + "static/media/licenta20.ef378c84.png";